import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box } from '@mui/material'
import { Add, QrCode2 } from '@mui/icons-material'
import { PageHeader, Button, DataTable, StatusChip, Card, PermissionGate, usePermissions } from '@components/common'
import { AssetForm } from '@components/assets'
import { toast } from 'react-toastify'
import api from '@services/api'

const columns = [
  { field: 'asset_tag', headerName: 'Asset Tag', sortable: true, width: 120 },
  { field: 'name', headerName: 'Name', sortable: true },
  {
    field: 'category_name',
    headerName: 'Category',
    sortable: true,
    renderCell: (value) => value || '-',
  },
  {
    field: 'location_name',
    headerName: 'Location',
    sortable: true,
    renderCell: (value) => value || '-',
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: true,
    renderCell: (value) => <StatusChip status={value} />,
  },
  {
    field: 'criticality',
    headerName: 'Criticality',
    sortable: true,
    renderCell: (value) => <StatusChip status={value} type="criticality" />,
  },
]

const AssetsList = () => {
  const navigate = useNavigate()
  const [assets, setAssets] = useState([])
  const [loading, setLoading] = useState(true)
  const [formOpen, setFormOpen] = useState(false)
  const { canCreate } = usePermissions()

  const fetchAssets = async () => {
    try {
      setLoading(true)
      const response = await api.get('/assets/assets/')
      setAssets(response.data.results || response.data)
    } catch (error) {
      console.error('Error fetching assets:', error)
      toast.error('Failed to load assets')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAssets()
  }, [])

  const handleFormSuccess = () => {
    fetchAssets()
  }

  return (
    <Box>
      <PageHeader
        title="Assets"
        subtitle="Manage all equipment and assets"
        breadcrumbs={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'Assets' },
        ]}
        actions={
          <>
            <Button
              variant="outlined"
              startIcon={<QrCode2 />}
              onClick={() => navigate('/assets/scan')}
            >
              Scan QR
            </Button>
            <PermissionGate permission="assets.create">
              <Button
                startIcon={<Add />}
                onClick={() => setFormOpen(true)}
              >
                Add Asset
              </Button>
            </PermissionGate>
          </>
        }
      />

      <Card>
        <DataTable
          columns={columns}
          data={assets}
          loading={loading}
          onRowClick={(row) => navigate(`/assets/${row.id}`)}
          searchPlaceholder="Search assets..."
          emptyMessage="No assets found"
        />
      </Card>

      <AssetForm
        open={formOpen}
        onClose={() => setFormOpen(false)}
        onSuccess={handleFormSuccess}
      />
    </Box>
  )
}

export default AssetsList
